import React, {useEffect, useState} from 'react';
import { ShoppingBag, Minus, Plus, MapPin, Phone, X, ChevronRight, ReceiptText, Ticket, ChevronDown } from 'lucide-react';
import {useSearchParams} from "react-router-dom";
import {loadTossPayments} from "@tosspayments/tosspayments-sdk";
import {getCouponUser, listCoupons, paymentReady, postRefundCoupon} from "../../api/advanced_coupon/advanced.api";
import {API_HOST} from "../../constants/axios";
import {Cookies} from "react-cookie";

// --- [Mock Data] ---
const VENDOR_INFO = {
    name: "짬뽕가온",
    description: "가심비를 가성비로 먹을 수 있는 기회. 선결제 쿠폰으로 더 저렴하게 즐기세요!",
    address: "서울 광진구 아차산로 461 1층",
    phone: "0507-1306-0954",
    logoUrl: "https://img.headless.co.kr/offline_qr_service/828173ae-c5a7-4470-816c-bd9bbf7f8aa1",
};
/*
const COUPONS = [
    {
        id: 1,
        name: "차돌숙주짬뽕",
        description: "100% 차돌박이가 듬뿍 들어간 차돌짬뽕",
        price: 11000,
        originalPrice: 12000,
        limit: "수량 제한 없음",
        imageUrl: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20241228_222%2F1735393139178OszmY_PNG%2F014.png",
        maxQuantity: 9,
    },
    {
        id: 2,
        name: "아차산더미 숙주탕수육 (소)",
        description: "짬뽕가온의 대표메뉴로 아삭한 숙주와 알까한 겨자소스에 찍어 먹는 탕수육",
        price: 21000,
        originalPrice: 23000,
        limit: "수량 제한 없음",
        imageUrl: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20241228_174%2F1735393572701NijId_PNG%2F015.png",
        maxQuantity: 9,
    },
    {
        id: 3,
        name: "(겨울한정)차돌크림짬뽕",
        description: "느끼할 줄 알았는데 매콤해서 계속 들어가는 짬뽕가온의 겨울 한정 메뉴",
        price: 13000,
        originalPrice: 14000,
        limit: "수량 제한 없음",
        imageUrl: "https://search.pstatic.net/common/?src=https%3A%2F%2Fldb-phinf.pstatic.net%2F20251223_176%2F1766489430613URAJC_PNG%2F%25C2%25F7%25B5%25B9%25C5%25A9%25B8%25B2%25C2%25AB%25BB%25CD_%2528%25BC%25F6%25C1%25A4%2529.png",
        maxQuantity: 9,
    },
];
*/

const CouponPage = () => {
    const [query] = useSearchParams();
    const code = query.get("code")
    const [coupons, setCoupons] = useState([]);

    // 1. 유저 및 장바구니 상태
    const [user, setUser] = useState();
    const [cart, setCart] = useState({});

    // 2. 결제 결산(바텀 시트) 및 포인트 관련 상태
    const [showPaymentSheet, setShowPaymentSheet] = useState(false);
    const [usedPoints, setUsedPoints] = useState(0);

    // 3. 구매 내역 팝업 상태
    const [showHistoryModal, setShowHistoryModal] = useState(false);

    const [isKakaoReady, setIsKakaoReady] = useState(false);

    useEffect(() => {
        // 이미 로드되어 있다면 초기화만 확인하고 종료
        if (window.Kakao && window.Kakao.isInitialized()) {
            setIsKakaoReady(true);
            return;
        }

        // 스크립트 태그 생성
        const script = document.createElement('script');
        script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.2/kakao.min.js';
        script.integrity = 'sha384-TiCUE00h649CAMonG018J2ujOgDKW/kVWlChEuu4jK2vxfAAD0eZxzCKakxg55G4';
        script.crossOrigin = 'anonymous';
        script.async = true;

        // 로드 완료 후 실행될 콜백
        script.onload = () => {
            if (window.Kakao && !window.Kakao.isInitialized()) {
                window.Kakao.init("4769c1c77b648769dae096a2a38a126e"); // 키 초기화
                console.log('Kakao SDK Initialized');
                setIsKakaoReady(true);
            }
        };

        script.onerror = () => {
            console.error('Kakao SDK Load Failed');
        };

        document.head.appendChild(script);
    }, []);

    useEffect(() => {
        listCoupons().then(({data}) => {
            console.log(data)
            setCoupons(data);
        })
    }, []);

    useEffect(() => {
        const cookies = new Cookies();
        const loginCode = cookies.get("omoplay_coupon_login_code")

        if (code) {
            cookies.set("omoplay_coupon_login_code", code, {
                sameSite: "strict",
                path: "/"
            })
            window.location.href = "/advanced/coupon"
        } else if (loginCode) {
            const handleSetUser = () => {
                getCouponUser(loginCode).then(({data}) => {
                    if (!data) {
                        alert("토큰이 만료되었습니다. 로그인을 다시 해주세요.")
                        cookies.remove("omoplay_coupon_login_code", {path: "/"});
                    } else {
                        setUser(data)
                    }
                })
            }

            handleSetUser()

            document.addEventListener('visibilitychange', handleSetUser);

            return () => {
                document.removeEventListener('visibilitychange', handleSetUser);
            };
        }
    }, [code]);

    // --- [계산 로직] ---
    const formatPrice = (price) => new Intl.NumberFormat('ko-KR').format(price);

    const totalItemAmount = Object.entries(cart).reduce((sum, [id, qty]) => {
        const coupon = coupons.find((c) => c.id === parseInt(id));
        return sum + (coupon ? coupon.price * qty : 0);
    }, 0);

    const totalCount = Object.values(cart).reduce((sum, qty) => sum + qty, 0);
    const finalPaymentAmount = totalItemAmount - usedPoints;

    // --- [핸들러] ---
    const handleKakaoLogin = () => {
        if (!isKakaoReady || !window.Kakao) {
            alert('카카오 로그인을 준비 중입니다. 잠시 후 다시 시도해주세요.');
            return;
        }
        window.Kakao.Auth.authorize({
            redirectUri: "https://api.omoplay.com/kakao/auth/token",
            state: `530f9203-a97f-465a-8bb3-f2cfd58edd0d,coupon,${window.location.href}`
        });
    };

    const handleQuantityChange = (id, delta, max) => {
        setCart((prev) => {
            const currentQty = prev[id] || 0;
            const newQty = currentQty + delta;
            if (newQty < 0) return prev;
            if (newQty > max) {
                alert(`최대 ${max}개까지만 구매 가능합니다.`);
                return prev;
            }
            const newCart = { ...prev, [id]: newQty };
            if (newQty === 0) delete newCart[id];
            return newCart;
        });
    };

    const openPaymentSheet = () => {
        // if (!user) { alert("로그인이 필요합니다."); return; }
        if (totalCount === 0) return;
        setUsedPoints(0);
        setShowPaymentSheet(true);
    };

    const handlePointInput = (e) => {
        const val = parseInt(e.target.value.replace(/[^0-9]/g, '')) || 0;
        const maxUseable = Math.min(user.points, totalItemAmount);
        if (val > maxUseable) setUsedPoints(maxUseable);
        else setUsedPoints(val);
    };

    const handlePointUseAll = () => {
        const maxUseable = Math.min(user.points, totalItemAmount);
        setUsedPoints(maxUseable);
    };

    // [NEW] 환불 처리 핸들러
    const handleRefund = (couponId) => {
        if (window.confirm("해당 쿠폰을 환불하시겠습니까?\n환불 시 쿠폰을 더이상 사용할 수 없습니다.")) {
            postRefundCoupon(couponId).then(({data}) => {
                if (data !== "success") {
                    alert("환불에 실패했습니다.\n이미 쿠폰을 사용했거나 환불이 진행 중입니다.")
                }
                window.location.reload();
            })
        }
    };

    // [NEW] 쿠폰 상세 이동 핸들러
    const handleGoToDetail = (couponId) => {
        window.location.href = `/advanced/coupon/usage?id=${couponId}`;
    };

    const requestTossPayment = () => {
        const orderId = Date.now().toString()
        const orderList = Object.entries(cart).map(([id, qty]) => {
            const item = coupons.find(c => c.id === parseInt(id));
            return ({ id: id, price: item.price, quantity: qty })
        } )

        paymentReady(orderId, user.name, user.id, finalPaymentAmount, orderList, usedPoints).then(({data}) => {
            if (data !== "success") {
                alert(data)
                return
            }

            loadTossPayments("live_gck_BX7zk2yd8yLwnb6j7moArx9POLqK").then((tossPayments) => {
                const dateNum = Date.now()
                const widgetWindow = tossPayments.widgets({customerKey: `${dateNum}`});

                widgetWindow.requestPaymentWindow(
                    {
                        amount: { currency: 'KRW', value: Number(finalPaymentAmount) },
                        orderId: orderId,
                        orderName: `[짬뽕가온] ${user.name}님 쿠폰 결제`,
                        customerName: user.name,
                        successUrl: API_HOST + `/advanced/coupon/payment/success`,
                        failUrl: window.location.origin + `/payment/error`
                    },
                    {
                        variantKey: {
                            paymentMethod: "DEFAULT",
                            agreement: "AGREEMENT",
                        },
                    }
                ).catch((err) => { alert(err) })
                /*
                const payment = tossPayments.payment({customerKey: `${dateNum}`});
                payment.requestPayment({
                    method: 'CARD',
                    amount: { currency: 'KRW', value: Number(finalPaymentAmount) },
                    orderId: orderId,
                    orderName: `${user.name}님 쿠폰 결제`,
                    customerName: user.name,
                    successUrl: API_HOST + `/advanced/coupon/payment/success`,
                    failUrl: window.location.origin + `/payment/error`
                }).catch((err) => { console.error(err); })
                */
            })
            setShowPaymentSheet(false);
        }).catch((err) => { alert(err) })
    };

    const goToKakaoChannel = (publicId) => {
        window.Kakao.Channel.addChannel({
            channelPublicId: publicId
        });
    }

    return (
        <div className="min-h-screen bg-gray-100 flex justify-center font-sans text-gray-800">
            <div className="w-full max-w-md bg-white shadow-xl min-h-screen flex flex-col relative">

                {/* --- 헤더 --- */}
                <header className="bg-white p-6 pb-4 border-b border-gray-100">
                    {user && (
                        <div className="mb-4 p-3 bg-gray-50 rounded-lg flex items-center justify-between">
                            <div className="flex items-center gap-3">
                                <div
                                    className="w-8 h-8 rounded-full bg-yellow-400 flex items-center justify-center text-xs font-bold text-black">K
                                </div>
                                <span className="text-sm text-gray-700"><span className="font-bold">{user.name}</span>님</span>
                            </div>
                            <div className="flex items-center gap-2 text-xs font-bold bg-blue-50 px-2 py-1 rounded-md pointer"
                                 onClick={() => setShowHistoryModal(true)}>
                                <div>쿠폰내역</div>
                                <ReceiptText size={18}/>
                            </div>
                        </div>
                    )}

                    <div className="flex items-start gap-4">
                        {VENDOR_INFO.logoUrl ? (
                            <img src={VENDOR_INFO.logoUrl} alt="로고"
                                 className="w-16 h-16 rounded-full border border-gray-100 object-cover flex-shrink-0"/>
                        ) : (
                            <div
                                className="w-16 h-16 rounded-full bg-blue-50 text-blue-500 flex items-center justify-center flex-shrink-0">
                                <ShoppingBag size={24}/>
                            </div>
                        )}
                        <div className="flex-1">
                            <h1 className="text-xl font-bold mb-1 text-gray-900">{VENDOR_INFO.name}</h1>
                            <p className="text-sm text-gray-500 leading-snug mb-3">{VENDOR_INFO.description}</p>
                            <div className="space-y-1">
                                <div className="flex items-center text-xs text-gray-400 gap-1">
                                    <MapPin size={12}/><span>{VENDOR_INFO.address}</span>
                                </div>
                                <div className="flex items-center text-xs text-gray-400 gap-1">
                                    <Phone size={12}/><span>{VENDOR_INFO.phone}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* --- 메인 컨텐츠 영역 (쿠폰 + 환불규정 + 푸터) --- */}
                <main className="flex-1 bg-gray-50 pb-32 overflow-y-auto">

                    {/* 1. 쿠폰 리스트 */}
                    <div className="p-4 space-y-4">
                        {coupons.map((coupon) => (
                            <div key={coupon.id} className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-200 group">
                                <div className="relative h-48 overflow-hidden">
                                    <img src={coupon.imageUrl} alt={coupon.productName} className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"/>
                                    {coupon.originalPrice && (
                                        <div className="absolute top-0 left-0 bg-red-500 text-white text-xs font-bold px-3 py-1 rounded-br-lg">
                                            {Math.round((1 - coupon.price / coupon.originalPrice) * 100)}% SAVE
                                        </div>
                                    )}
                                </div>
                                <div className="p-5">
                                    <h3 className="text-lg font-bold text-gray-900 leading-tight mb-1">{coupon.productName}</h3>
                                    <p className="text-xs text-gray-500 mb-2">{coupon.limit}개</p>
                                    <p className="text-sm text-gray-600 mb-4">{coupon.productDescription}</p>
                                    <div className="border-t border-dashed border-gray-200 pt-4 flex items-end justify-between">
                                        <div>
                                            {coupon.originalPrice && <span className="text-xs text-gray-400 line-through mr-2">{formatPrice(coupon.originalPrice)}원</span>}
                                            <div className="text-xl font-bold text-gray-900">{formatPrice(coupon.price)}<span className="text-sm font-normal text-gray-500 ml-0.5">원</span></div>
                                        </div>
                                        <div className="flex items-center bg-gray-100 rounded-lg p-1">
                                            <button onClick={() => handleQuantityChange(coupon.id, -1, coupon.maxQuantity)} disabled={!cart[coupon.id]} className={`p-2 rounded-md ${!cart[coupon.id] ? 'text-gray-300' : 'bg-white text-gray-700 shadow-sm'}`}><Minus size={16} /></button>
                                            <span className="w-8 text-center font-bold text-gray-900">{cart[coupon.id] || 0}</span>
                                            <button onClick={() => handleQuantityChange(coupon.id, 1, coupon.maxQuantity)} disabled={coupon.limit === 0} className={`p-2 rounded-md active:bg-gray-50 ${coupon.limit === 0 ? 'text-gray-300' : 'bg-white text-gray-700 shadow-sm'}`}><Plus size={16} /></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* 2. 환불 정책 (Accordion) */}
                    <div className="px-4 pb-4">
                        <details className="group bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                            <summary className="flex justify-between items-center p-4 cursor-pointer list-none select-none bg-white hover:bg-gray-50 transition-colors">
                                <span className="text-sm font-bold text-gray-700">이용안내 및 환불 규정</span>
                                <span className="text-gray-400 transition-transform duration-300 group-open:rotate-180">
                                    <ChevronDown size={18} />
                                </span>
                            </summary>
                            <div className="px-5 pb-5 text-xs text-gray-500 space-y-2 leading-relaxed border-t border-gray-100 bg-gray-50 pt-4 animate-[fadeIn_0.3s]">
                                <div className="space-y-1">
                                    <p className="font-bold text-gray-700">1. 취소 및 환불 규정</p>
                                    <p>• <strong>유효기간 내:</strong> 미사용 티켓 100% 환불 가능</p>
                                    <p>• <strong>유효기간 만료 후:</strong> 구매일로부터 5년 내 90% 환불</p>
                                    <p>• <strong>사용 완료된 티켓:</strong> 사용 처리 후 환불 불가</p>
                                </div>
                                <div className="space-y-1 pt-2">
                                    <p className="font-bold text-gray-700">2. 이용 및 연장 안내</p>
                                    <p>• 유효기간 만료 전, 3개월 단위로 유효기간 연장이 가능합니다.</p>
                                    <p>• 구매 후 [로그인 > 구매내역]에서 확인 가능합니다.</p>
                                    <p>• 업체 사정에 따라 구매가 제한될 수 있습니다.</p>
                                    <p>• 타 쿠폰 및 할인 혜택과 중복 사용이 제한될 수 있습니다.</p>
                                    <p>• 매장 재고 사정에 따라 이용이 제한될 수 있습니다.</p>
                                </div>
                            </div>
                        </details>
                    </div>

                    {/* 3. [NEW] Footer 영역 */}
                    <footer className="bg-gray-100 p-8 border-t border-gray-200 mt-4 text-[11px] text-gray-500 leading-relaxed">
                        <div className="flex flex-col gap-6">
                            {/* 로고 */}
                            <div>
                                <a href="https://omoplay.com/" target="_blank" rel="noopener noreferrer">
                                    <img
                                        src="https://omoplay.com/wp-content/plugins/omoplay-pages/assets/img/common/logo.svg"
                                        alt="OMOPLAY"
                                        className="h-5 opacity-70 mb-4"
                                    />
                                </a>

                                {/* 링크 */}
                                <div className="flex flex-wrap gap-2 mb-3 text-gray-600 font-bold">
                                    <a href="https://omoplay.com/terms-of-use/" target="_blank" rel="noopener noreferrer">이용약관</a>
                                    <span className="text-gray-300">|</span>
                                    <a href="https://omoplay.com/privacy-policy/" target="_blank" rel="noopener noreferrer">개인정보처리방침</a>
                                </div>

                                {/* 회사 정보 */}
                                <div className="space-y-1">
                                    <p>
                                        회사명 <span className="mx-1 text-gray-300">|</span> 헤드리스 주식회사 <span className="mx-1 text-gray-300">|</span> 대표 <span className="mx-1 text-gray-300">|</span> 남궁지환
                                    </p>
                                    <p>
                                        주소 <span className="mx-1 text-gray-300">|</span> 서울특별시 마포구 마포대로 122(프론트원), 11,12층
                                    </p>
                                    <p>
                                        사업자등록번호 <span className="mx-1 text-gray-300">|</span> 694-86-02485
                                    </p>
                                    <p>
                                        통신판매번호 <span className="mx-1 text-gray-300">|</span> 2022-서울강남-00470
                                    </p>
                                    <p>
                                        헤드리스(주)는 통신판매중개자이며, 통신판매의 당사자가 아닙니다.
                                        상품, 상품정보 및 거래 등에 관한 의무와 책임은 판매자에게 있습니다.
                                    </p>
                                </div>
                            </div>

                            {/* 우측/하단 CTA 및 연락처 */}
                            <div className="pt-4 border-t border-gray-200">
                                <div className="space-y-1">
                                    <p>
                                        전화 <span className="mx-1 text-gray-300">|</span>
                                        <a href="tel:02-6953-1836" className="hover:text-blue-500">02-6953-1836</a>
                                    </p>
                                    <p>
                                        이메일 <span className="mx-1 text-gray-300">|</span>
                                        <a href="mailto:contact@headless.co.kr" className="hover:text-blue-500">contact@headless.co.kr</a>
                                    </p>
                                    <p className="mt-3 text-gray-400">Ⓒheadless Inc. All rights reserved</p>
                                </div>
                            </div>
                        </div>
                    </footer>
                </main>

                {/* --- 하단 플로팅 바 --- */}
                <div
                    className="fixed bottom-0 w-full max-w-md bg-white border-t border-gray-200 shadow-[0_-4px_10px_rgba(0,0,0,0.05)] p-4 safe-area-bottom z-10">
                    <div className="flex justify-between items-center mb-3">
                        <span className="text-gray-600 text-sm">총 수량 <span
                            className="font-bold text-gray-900">{totalCount}</span>개</span>
                        <span className="text-xl font-bold text-blue-600">
                          {formatPrice(totalItemAmount)}<span className="text-base text-gray-500 font-normal">원</span>
                        </span>
                    </div>
                    {!user ? (
                        <button
                            onClick={handleKakaoLogin}
                            className="w-full py-4 rounded-xl text-lg font-bold bg-[#FEE500] text-[#191919] hover:bg-[#FDD835] transition-colors flex items-center justify-center gap-2"
                        >
                            <svg viewBox="0 0 24 24" fill="currentColor" className="w-6 h-6">
                                <path
                                    d="M12 3C5.925 3 1 6.925 1 11.775C1 14.866 3.016 17.587 6.015 19.125C5.82 19.794 5.375 21.375 5.375 21.375C5.375 21.375 8.25 19.866 9.688 18.9C10.422 19.006 11.194 19.059 12 19.059C18.075 19.059 23 15.134 23 10.284C23 5.434 18.075 3 12 3Z"/>
                            </svg>
                            카카오로 시작하기
                        </button>
                    ) : (
                        <button
                            onClick={openPaymentSheet}
                            disabled={totalCount === 0}
                            className={`w-full py-4 rounded-xl text-lg font-bold transition-all ${totalCount > 0 ? 'bg-blue-600 text-white hover:bg-blue-700 shadow-lg shadow-blue-200' : 'bg-gray-200 text-gray-400 cursor-not-allowed'}`}
                        >
                            {totalCount > 0 ? `${formatPrice(totalItemAmount)}원 결제하기` : '쿠폰을 선택해주세요'}
                        </button>
                    )}
                </div>

                {/* --- 결제 결산 모달 --- */}
                {showPaymentSheet && (
                    <>
                        <div className="fixed inset-0 bg-black/60 z-40 transition-opacity"
                             onClick={() => setShowPaymentSheet(false)}/>
                        <div
                            className="fixed bottom-0 w-full max-w-md bg-white z-50 rounded-t-3xl shadow-2xl animate-[slideUp_0.3s_ease-out] overflow-hidden flex flex-col max-h-[90vh]">
                            <div
                                className="p-5 border-b border-gray-100 flex justify-between items-center bg-white sticky top-0">
                                <h2 className="text-lg font-bold">결제 정보 확인</h2>
                                <button onClick={() => setShowPaymentSheet(false)}
                                        className="p-2 text-gray-400 hover:text-gray-800"><X size={24}/></button>
                            </div>
                            <div className="p-5 overflow-y-auto safe-area-bottom pb-32">
                                <h3 className="text-sm font-bold text-gray-500 mb-3">주문 상품</h3>
                                <div className="space-y-3 mb-8">
                                    {Object.entries(cart).map(([id, qty]) => {
                                        const item = coupons.find(c => c.id === parseInt(id));
                                        return (
                                            <div key={id} className="flex justify-between items-center text-sm">
                                                <span className="text-gray-800">{item.name} <span
                                                    className="text-blue-600 font-bold">x {qty}</span></span>
                                                <span className="font-bold">{formatPrice(item.price * qty)}원</span>
                                            </div>
                                        );
                                    })}
                                    <div
                                        className="border-t border-gray-100 pt-3 flex justify-between items-center font-bold">
                                        <span>상품 총액</span><span>{formatPrice(totalItemAmount)}원</span>
                                    </div>
                                </div>
                                {/*
                                <h3 className="text-sm font-bold text-gray-500 mb-3 flex items-center justify-between">
                                    <span>포인트 사용</span><span
                                    className="text-xs font-normal text-blue-600">보유 {formatPrice(user.points)}P</span>
                                </h3>
                                <div className="bg-gray-50 rounded-xl p-4 mb-8">
                                    <div className="flex items-center gap-2 mb-2">
                                        <input type="text" value={usedPoints} onChange={handlePointInput}
                                               className="flex-1 bg-white border border-gray-200 rounded-lg p-3 text-right font-bold text-gray-900 focus:outline-none focus:border-blue-500"
                                               placeholder="0"/>
                                        <span className="font-bold text-gray-500">P</span>
                                    </div>
                                    <div className="flex justify-between items-center">
                                        <p className="text-xs text-gray-500">*
                                            최대 {formatPrice(Math.min(user.points, totalItemAmount))}P 사용 가능</p>
                                        <button onClick={handlePointUseAll}
                                                className="text-xs bg-white border border-gray-300 px-2 py-1 rounded text-gray-600 hover:bg-gray-100">전액
                                            사용
                                        </button>
                                    </div>
                                </div>
                                */}
                                <div className="space-y-2 text-sm text-gray-600 mb-6">
                                    <div className="flex justify-between">
                                        <span>총 상품 금액</span><span>{formatPrice(totalItemAmount)}원</span>
                                    </div>
                                    {/*
                                    <div className="flex justify-between text-red-500">
                                        <span>포인트 할인</span><span>- {formatPrice(usedPoints)}원</span>
                                    </div>
                                    */}
                                </div>
                            </div>
                            <div className="border-t border-gray-200 p-4 bg-white sticky bottom-0 safe-area-bottom">
                                <div className="flex justify-between items-end mb-4 px-1">
                                    <span className="font-bold text-gray-900 text-lg">최종 결제 금액</span>
                                    <span
                                        className="font-bold text-2xl text-blue-600">{formatPrice(finalPaymentAmount)}원</span>
                                </div>
                                {
                                    !user.isFriend ? (
                                        <button
                                            onClick={() => goToKakaoChannel(user.publicId)}
                                            className="w-full py-4 rounded-xl bg-[#FEE500] text-lg font-bold shadow-lg shadow-blue-200 hover:bg-[#FDD835] transition-colors flex justify-center items-center gap-2"
                                        >
                                            짬뽕가온 채널 친구 추가 후 결제하기
                                        </button>
                                    ) : (
                                        <button
                                            onClick={requestTossPayment}
                                            className="w-full py-4 rounded-xl bg-blue-600 text-white text-lg font-bold shadow-lg shadow-blue-200 hover:bg-blue-700 transition-colors flex justify-center items-center gap-2"
                                        >
                                            결제하기 <ChevronRight size={20}/>
                                        </button>
                                    )
                                }
                            </div>
                        </div>
                    </>
                )}

                {/* --- [구매 내역 팝업 (Center Modal)] --- */}
                {showHistoryModal && (
                    <div className="fixed inset-0 z-50 flex items-center justify-center px-4">
                        <div className="absolute inset-0 bg-black/60 transition-opacity"
                             onClick={() => setShowHistoryModal(false)}/>

                        <div
                            className="relative bg-white w-full max-w-sm rounded-2xl shadow-xl overflow-hidden max-h-[70vh] flex flex-col animate-[fadeIn_0.2s_ease-out]">
                            <div className="p-4 border-b border-gray-100 flex justify-between items-center bg-white">
                                <h3 className="text-lg font-bold text-gray-900">구매 내역</h3>
                                <button onClick={() => setShowHistoryModal(false)}
                                        className="text-gray-400 hover:text-gray-600"><X size={24}/></button>
                            </div>

                            <div className="overflow-y-auto p-4 space-y-3 bg-gray-50">
                                {user.coupons.length > 0 ? (
                                    user.coupons.map((item) => (
                                        <div
                                            key={item.id}
                                            // [DESIGN] 클릭 가능한 카드 형태로 변경 (Cursor, Active Scale, Bg Color)
                                            className="bg-white p-4 rounded-xl border border-gray-100 relative group cursor-pointer active:scale-[0.98] active:bg-blue-50 transition-all shadow-sm"
                                        >
                                            {/* [DESIGN] 우측 화살표 아이콘 (Navigation Hint) */}
                                            <div
                                                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-300 group-hover:text-blue-500 transition-colors">
                                                <ChevronRight size={20}/>
                                            </div>

                                            <div className="pr-6">
                                                <div className="flex justify-between items-start mb-2"
                                                     onClick={() => handleGoToDetail(item.id)}>
                                                    <div className="flex items-center gap-2">
                                                        <Ticket size={14} className="text-blue-500"/>
                                                        <span
                                                            className="text-xs text-gray-500 font-medium">{item.createdAt}</span>
                                                    </div>
                                                    <span className={`text-xs font-bold px-2 py-0.5 rounded-full ${
                                                        (item.isUsed === true || item.isRefund === true) ? 'bg-gray-100 text-gray-500' : 'bg-blue-100 text-blue-600'
                                                    }`}>
                                                        {item.isRefund ? '환불됨' : (item.isUsed ? '사용완료' : '사용가능')}
                                                    </span>
                                                </div>

                                                <h4 className="font-bold text-gray-800 text-base mb-1"
                                                    onClick={() => handleGoToDetail(item.id)}>{item.name}</h4>

                                                <div className="text-xs text-gray-400 mb-3 flex items-center gap-1"
                                                     onClick={() => handleGoToDetail(item.id)}>
                                                    <span className="w-1 h-1 bg-gray-300 rounded-full"></span>
                                                    유효기간: ~ {item.expiredAt}
                                                </div>

                                                <div
                                                    className="flex justify-between items-end pt-2 border-t border-dashed border-gray-100">
                                                    {/* 환불 버튼 (클릭 시 전파 방지) */}
                                                    {(!item.isUsed && !item.isRefund) ? (
                                                        <button
                                                            onClick={() => handleRefund(item.id)}
                                                            className="text-xs bg-white border border-gray-200 text-red-500 px-3 py-1.5 rounded-lg hover:bg-red-50 hover:border-red-100 transition-colors z-10"
                                                        >
                                                            환불신청
                                                        </button>
                                                    ) : (
                                                        <span></span>
                                                    )}
                                                    <div
                                                        className={`font-bold text-gray-900 text-lg${item.isRefund ? ' line-through' : ''}`}>
                                                        {formatPrice(item.price)}<span
                                                        className="text-sm font-normal text-gray-500 ml-0.5">원</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div
                                        className="text-center py-12 text-gray-400 text-sm flex flex-col items-center gap-2">
                                        <ReceiptText size={40} className="text-gray-300 mb-2"/>
                                        구매 내역이 없습니다.
                                    </div>
                                )}
                            </div>

                            {/* --- [NEW] 환불 정책 (Accordion UI) --- */}
                            {/*
                            <div className="pt-2">
                                <details
                                    className="group bg-white rounded-xl border border-gray-200 overflow-hidden shadow-sm">
                                    <summary
                                        className="flex justify-between items-center p-4 cursor-pointer list-none select-none bg-white hover:bg-gray-50 transition-colors">
                                        <span className="text-sm font-bold text-gray-700">이용안내 및 환불 규정</span>
                                        <span
                                            className="text-gray-400 transition-transform duration-300 group-open:rotate-180">
                                    <ChevronDown size={18}/>
                                </span>
                                    </summary>
                                    <div
                                        className="px-5 pb-5 text-xs text-gray-500 space-y-2 leading-relaxed border-t border-gray-100 bg-gray-50 pt-4 animate-[fadeIn_0.3s]">
                                        <div className="space-y-1">
                                            <p className="font-bold text-gray-700">1. 환불 규정</p>
                                            <p>• <strong>유효기간 내 미사용 쿠폰:</strong> 전액 환불 가능</p>
                                            <p>• <strong>유효기간 만료 후:</strong> 환불 불가 (미사용 건 포함)</p>
                                            <p>• <strong>사용 완료된 쿠폰:</strong> 환불 불가</p>
                                        </div>
                                        <div className="space-y-1 pt-2">
                                            <p className="font-bold text-gray-700">2. 이용 안내</p>
                                            <p>• 구매 후 구매내역에서 쿠폰을 확인할 수 있습니다.</p>
                                            <p>• 타 쿠폰 및 할인 혜택과 중복 사용이 불가할 수 있습니다.</p>
                                            <p>• 매장 사정에 따라 조기 품절될 수 있습니다.</p>
                                        </div>
                                        <div className="pt-2 mt-2 border-t border-gray-200 text-gray-400">
                                            문의: {VENDOR_INFO.phone} ({VENDOR_INFO.name})
                                        </div>
                                    </div>
                                </details>
                            </div>
                            */}

                            <div className="p-4 border-t border-gray-100 bg-white">
                                <button onClick={() => setShowHistoryModal(false)}
                                        className="w-full py-3 bg-gray-100 text-gray-700 font-bold rounded-xl hover:bg-gray-200 transition-colors">
                                    닫기
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>

            <style>{`
                @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
                @keyframes fadeIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
            `}</style>

        </div>
    );
};

export default CouponPage;